module.exports = __webpack_public_path__ + "media/rightCode.4c2fa478.mp3";